module.exports = __webpack_public_path__ + "static/media/arrow-right-dark28405b7b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/therapist/images/arrow-right-dark.svg
// module id = 177
// module chunks = 0